export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
  },
  LEAD: {
    Title: 'Lead',
    Color: '#FFD54F',
  },
  CG_SEARCH: {
    Title: 'CG Search',
    Color: '#FDC200',
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#767676',
  },
};
